import React from "react";
import { css } from "@emotion/react";

export const SparePartsLoadingScreen = (
  <div
    css={css`
      min-height: 50vh;
    `}
  />
);
